import React, { useEffect, useState, useRef } from "react";
import confetti from "canvas-confetti";
import RamzanTheme from "./RamzanTheme/RamzanTheme";
import "./FestivalSpecial.css";

const festivals = [
    {
        name: "Diwali",
        start: "2026-11-10",
        end: "2026-11-15",
        message: "🪔 Happy Diwali! Drive safe and shine bright!",
        doodle: "/images/festivals/diwali.png",
        effect: "diyas",
        color: "#ff9a00"
    },
    {
        name: "Ugadi",
        start: "2027-04-07",
        end: "2027-04-07",
        title: "Happy Ugadi",
        message: "🌿 Happy Ugadi! Wishing you Prosperity, happiness & success!",
        doodle: "/images/festivals/ugadi.png",
        effect: "ugadi",
        color: "#228b22"
    },
    {
        name: "Ramzan",
        start: "2027-03-10",
        end: "2027-03-10",
        message: "🌙 Ramadan Kareem! Peace, blessings & safe journeys!",
        doodle: "/images/festivals/ramzan.png",
        effect: "ramzan",
        color: "#0b3d1b"
    },
    {
        name: "Christmas",
        start: "2026-12-23",
        end: "2026-12-26",
        message: "🎄 Merry Christmas! Wishing joyful journeys!",
        doodle: "/images/festivals/christmas.png",
        effect: "christmas",
        color: "#ff0000"
    },
    {
        name: "NewYear",
        start: "2027-01-01",
        end: "2027-01-02",
        message: "🎉 Happy New Year! Track amazing journeys!",
        doodle: "/images/festivals/newyear.png",
        effect: "balloons",
        color: "#00bfff"
    },
    {
        name: "Sankranti",
        start: "2027-01-13",
        end: "2027-01-16",
        message: "🪁 Happy Sankranti! Fly high and travel safe!",
        doodle: "/images/festivals/sankranti.png",
        effect: "kites",
        color: "#ffd700"
    },
    {
        name: "Holi",
        start: "2027-03-22",
        end: "2027-03-22",
        message: "🌈 Happy Holi! Enjoy colors and joy!",
        doodle: "/images/festivals/holi.png",
        effect: "colors",
        color: "#ff1493"
    },
    {
        name: "IndependenceDay",
        start: "2026-08-13",
        end: "2026-08-13",
        message: "🇮🇳 Happy Independence Day! Proud moments!",
        doodle: "/images/festivals/independence.png",
        effect: "flags",
        background: "linear-gradient(90deg, #FF9933, #FFFFFF, #138808)", // India flag colors
        textColor: "#000088"
    },
    // {
    //     name: "Easter",
    //     start: "2026-04-05",
    //     end: "2026-04-07",
    //     message: "🐰 Happy Easter! Celebrate joyfully!",
    //     doodle: "/images/festivals/easter.png",
    //     effect: "eggs",
    //     color: "#ff69b4"
    // }
];

export default function FestivalSpecial() {
    const [festival, setFestival] = useState(null);
    const [showConfetti, setShowConfetti] = useState(false);
    const [showUgadiPopup, setShowUgadiPopup] = useState(false);
    const [showAnimation, setShowAnimation] = useState(true);
    const [animationKey, setAnimationKey] = useState(0);
    const audioRef = useRef(null);

    const [playSound, setPlaySound] = useState(false);

    const toggleSound = () => {
        if (!audioRef.current) return;

        if (playSound) {
            audioRef.current.pause();
        } else {
            audioRef.current.play();
        }

        setPlaySound(!playSound);
    };

    // const festivalType = "ramzan";

    useEffect(() => {
        if (!festival) return;
        const interval = setInterval(() => {
            setShowAnimation(false);

            setTimeout(() => {
                setAnimationKey(prev => prev + 1);
                setShowAnimation(true);
            }, 200);

        }, 50000);

        return () => clearInterval(interval);
    }, [festival]);

    useEffect(() => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const active = festivals.find((f) => {
            const start = new Date(f.start);
            start.setHours(0, 0, 0, 0);
            const end = new Date(f.end);
            end.setHours(0, 0, 0, 0);
            return today >= start && today <= end;
        });

        if (active) setFestival(active);
    }, []);

    useEffect(() => {
        if (!festival) return;

        // Balloons/Confetti effect
        if (festival.effect === "balloons" || festival.effect === "colors") {
            setShowConfetti(true);
            confetti({
                particleCount: 200,
                spread: 120,
                startVelocity: 40,
                origin: { y: 0.7 }
            });
            const timer = setTimeout(() => setShowConfetti(false), 8000);
            return () => clearTimeout(timer);
        }

        // Diyas effect
        if (festival.effect === "diyas") {
            const duration = 4000;
            const end = Date.now() + duration;
            (function frame() {
                confetti({
                    particleCount: 6,
                    spread: 90,
                    origin: { x: Math.random(), y: Math.random() * 0.6 }
                });
                if (Date.now() < end) requestAnimationFrame(frame);
            })();
        }
    }, [festival]);

    useEffect(() => {
        if (festival?.effect === "ugadi") {
            setShowUgadiPopup(true);

            setTimeout(() => {
                setShowUgadiPopup(false);
            }, 5000);
        }
    }, [festival]);


    if (!festival) return null;

    const duplicatedMessage = Array(4).fill(
        `${festival.message} 🎉 🚗 Track smarter with WAY4TRACK`
    );

    const IndianFlag = () => (
        <svg width="40" height="26" viewBox="0 0 60 40">
            {/* Saffron */}
            <rect width="60" height="13.33" fill="#FF9933" />

            {/* White */}
            <rect y="13.33" width="60" height="13.33" fill="#FFFFFF" />

            {/* Green */}
            <rect y="26.66" width="60" height="13.34" fill="#138808" />

            {/* Ashoka Chakra */}
            <circle cx="30" cy="20" r="4" fill="none" stroke="#000080" strokeWidth="1.5" />

            {/* Chakra spokes */}
            {[...Array(24)].map((_, i) => (
                <line
                    key={i}
                    x1="30"
                    y1="20"
                    x2="30"
                    y2="16"
                    stroke="#000080"
                    strokeWidth="0.5"
                    transform={`rotate(${i * 15} 30 20)`}
                />
            ))}
        </svg>
    );

    return (
        <>
            <div
                className="festival-bar"
                style={{
                    background:
                        festival.effect === "ramzn"
                            ? "transparent"
                            : (festival.background || festival.color)
                }}
            >
                <div className="festival-text-wrapper">
                    {duplicatedMessage.map((msg, idx) => (
                        <div key={idx} className="festival-text" style={{ color: festival.textColor || "#fff" }}>
                            {msg}
                        </div>
                    ))}
                </div>

                {festival.effect === "ramzan" && (
                    <>
                        <div className="ramzan-lantern left">
                            <div className="lantern-light"></div>
                        </div>

                        <div className="ramzan-lantern right">
                            <div className="lantern-light"></div>
                        </div></>
                )}
            </div>

            {/* {festival?.effect === "ramzan" && <RamzanTheme />} */}

            {festival.effect === "ramzan" && (
                <div className="ramzan-container">

                    {/* 🌙 Moon */}
                    <div className="ramzan-moon">🌙</div>

                    {/* ⭐ Stars */}
                    {Array.from({ length: 25 }).map((_, i) => (
                        <div
                            key={"star" + i}
                            className="ramzan-star"
                            style={{
                                left: `${Math.random() * 100}%`,
                                top: `${Math.random() * 60}%`,
                                animationDelay: `${Math.random() * 5}s`
                            }}
                        >
                            ✨
                        </div>
                    ))}

                    {/* 🕌 Mosque silhouette */}
                    <div className="ramzan-mosque">🕌</div>

                    {/* 🏮 Floating Lanterns */}
                    {Array.from({ length: 6 }).map((_, i) => (
                        <div
                            key={"lantern" + i}
                            className="ramzan-floating-lantern"
                            style={{
                                left: `${Math.random() * 100}%`,
                                animationDuration: `${8 + Math.random() * 6}s`
                            }}
                        >
                            🏮
                        </div>
                    ))}

                    {/* ✨ Sparkles */}
                    {Array.from({ length: 20 }).map((_, i) => (
                        <div
                            key={"spark" + i}
                            className="ramzan-sparkle"
                            style={{
                                left: `${Math.random() * 100}%`,
                                top: `${Math.random() * 100}%`,
                                animationDelay: `${Math.random() * 4}s`
                            }}
                        >
                            ✦
                        </div>
                    ))}
                    {/* <audio ref={audioRef} src="/sounds/ramzan_background_music.mp3" loop /> */}
                    {/* <audio ref={audioRef} loop preload="auto">
                        <source src="/sounds/ramzan_background_music.mp3" type="audio/mpeg" />
                        Your browser does not support audio.
                    </audio>
                    <button className="ramzan-sound-btn" onClick={toggleSound}>
                        {playSound ? "🔊 Sound On" : "🔇 Sound Off"}
                    </button> */}
                </div>
            )}

            {showAnimation && (
                <div className="ugadi-container">
                    {festival.effect === "ugadi" && (
                        <div className="ugadi-container">
                            {/* Mango Leaves */}
                            {Array.from({ length: 12 }).map((_, i) => (
                                <div
                                    key={"leaf" + i}
                                    className="ugadi-leaf ugadi-fall"
                                    style={{
                                        left: `${Math.random() * 100}%`,
                                        animationDuration: `${6 + Math.random() * 5}s`,
                                        fontSize: `${18 + Math.random() * 10}px`
                                    }}
                                >
                                    🍃
                                </div>
                            ))}

                            {/* Neem Flowers */}
                            {Array.from({ length: 15 }).map((_, i) => (
                                <div
                                    key={"flower" + i}
                                    className="ugadi-flower ugadi-fall"
                                    style={{
                                        left: `${Math.random() * 100}%`,
                                        animationDuration: `${5 + Math.random() * 4}s`,
                                        fontSize: `${20 + Math.random() * 8}px`
                                    }}
                                >
                                    🌼
                                </div>
                            ))}

                            {/* Pachadi Bowls */}
                            {Array.from({ length: 6 }).map((_, i) => (
                                <div
                                    key={"pachadi" + i}
                                    className="ugadi-pachadi ugadi-fall"
                                    style={{
                                        left: `${Math.random() * 100}%`,
                                        animationDuration: `${8 + Math.random() * 4}s`,
                                        fontSize: `${20 + Math.random() * 6}px`
                                    }}
                                >
                                    🥣
                                </div>
                            ))}

                            {/* 7 Tastes */}
                            {[
                                { icon: "🍯" },
                                { icon: "🌶" },
                                { icon: "🍋" },
                                { icon: "🧂" },
                                { icon: "🌿" },
                                { icon: "🥭" },
                                { icon: "🫘" }
                            ].map((taste, i) => (
                                <div
                                    key={"taste" + i}
                                    className="ugadi-taste ugadi-fall"
                                    style={{
                                        left: `${Math.random() * 100}%`,
                                        animationDuration: `${7 + Math.random() * 5}s`,
                                        fontSize: `${20 + Math.random() * 6}px`
                                    }}
                                >
                                    {taste.icon}
                                </div>
                            ))}
                        </div>
                    )}

                    {festival.effect === "kites" &&
                        Array.from({ length: 8 }).map((_, i) => (
                            <div
                                key={"kite" + i}
                                className="kite"
                                style={{
                                    left: `${Math.random() * 100}%`,
                                    animationDuration: `${6 + Math.random() * 5}s`
                                }}
                            >
                                🪁
                            </div>
                        ))}

                    {festival.effect === "balloons" &&
                        Array.from({ length: 12 }).map((_, i) => (
                            <div
                                key={"balloon" + i}
                                className="balloon"
                                style={{
                                    left: `${Math.random() * 100}%`,
                                    animationDuration: `${6 + Math.random() * 6}s`
                                }}
                            >
                                🎈
                            </div>
                        ))}

                    {festival.effect === "colors" &&
                        Array.from({ length: 20 }).map((_, i) => (
                            <div
                                key={"color" + i}
                                className="holi-color"
                                style={{
                                    left: `${Math.random() * 100}%`,
                                    animationDuration: `${3 + Math.random() * 5}s`
                                }}
                            >
                                🌸
                            </div>
                        ))}

                    {festival.effect === "flags" && Array.from({ length: 15 }).map((_, i) => (
                        <div key={"flag" + i} className="flag"
                            style={{ left: `${Math.random() * 100}%`, animationDuration: `${4 + Math.random() * 5}s`, fontSize: `${20 + Math.random() * 8}px` }}><IndianFlag /></div>
                    ))}

                    {/* Easter Eggs */}
                    {festival.effect === "eggs" && Array.from({ length: 12 }).map((_, i) => (
                        <div key={"egg" + i} className="egg fall"
                            style={{ left: `${Math.random() * 100}%`, animationDuration: `${5 + Math.random() * 5}s`, fontSize: `${22 + Math.random() * 6}px` }}>🥚</div>
                    ))}

                    {/* {showUgadiPopup && (
                    <div className="ugadi-popup">
                        <div className="ugadi-popup-content">
                            🌿 Happy Ugadi 🌿
                            <h1>{festival.message}</h1>
                            <p>Wishing you prosperity, happiness & success!</p>
                        </div>
                    </div>
                )} */}

                    {/* {festival.effect === "ugadi" && (
                    <div className="ugadi-rangoli">
                        🌸 🌼 🌺 🌼 🌸
                    </div>
                )} */}
                </div>
            )}
        </>
    );
}